import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/legal/terminos/page.tsx");
